// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"df90f10e","412":"29ec955a"}[chunkId] + ".css";
};